import {
  Avatar,
  Box,
  Chip,
  IconButton,
  Tooltip,
  Typography
} from '@mui/material';
import { LogoutOutlined, MenuOutlined } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import { useSocket } from '../contexts/SocketContext';
import { useLocation } from 'react-router-dom';
import { workspaceFor } from '../navigation/workspaces';
export default function Topbar({ onMenu }) {
  const { admin, logout, sessionEnding } = useAuth();
  const { isConnected } = useSocket();
  const space = workspaceFor(useLocation().pathname);
  const local = ['localhost', '127.0.0.1'].includes(window.location.hostname);
  const production =
    window.location.hostname === 'admin.zenoo.app' ||
    import.meta.env.VITE_API_URL?.startsWith('https://api.zenoo.app/');
  return (
    <Box
      component="header"
      sx={{
        minHeight: 70,
        px: { xs: 2, md: 4 },
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        borderBottom: '1px solid',
        borderColor: 'divider',
        background: '#FCFDFB'
      }}
    >
      <IconButton
        aria-label="Ouvrir le menu"
        onClick={onMenu}
        sx={{ display: { md: 'none' } }}
      >
        <MenuOutlined />
      </IconButton>
      <Typography sx={{ flex: 1, fontSize: 13, fontWeight: 600 }}>
        {space.label}
      </Typography>
      {sessionEnding && (
        <Chip
          role="status"
          size="small"
          color="warning"
          label="Session bientôt inactive"
        />
      )}
      <Chip
        size="small"
        variant="outlined"
        label={production ? 'Production' : local ? 'Local' : 'En ligne'}
        sx={{ display: { xs: 'none', sm: 'flex' }, fontSize: 11 }}
      />
      <Tooltip
        title={
          isConnected
            ? 'Connexion temps réel active'
            : 'Connexion temps réel interrompue'
        }
      >
        <Box
          aria-label={
            isConnected ? 'Temps réel connecté' : 'Temps réel déconnecté'
          }
          sx={{
            width: 7,
            height: 7,
            borderRadius: '50%',
            background: isConnected ? 'success.main' : 'warning.main'
          }}
        />
      </Tooltip>
      <Avatar
        sx={{
          width: 32,
          height: 32,
          background: 'primary.light',
          color: 'primary.dark',
          fontSize: 13
        }}
      >
        {admin?.firstName?.[0] || 'A'}
      </Avatar>
      <Typography sx={{ fontSize: 12, display: { xs: 'none', sm: 'block' } }}>
        {admin?.firstName}
      </Typography>
      <Tooltip title="Se déconnecter">
        <IconButton aria-label="Se déconnecter" onClick={logout} size="small">
          <LogoutOutlined sx={{ fontSize: 19 }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
